import React from 'react';

import { getFileMetadata } from 'src/utils/pdf';

import { useStepEditorContext } from 'src/store/step-editor';
import { uploadAssetToS3 } from 'src/common/helpers/file-upload';

export const useFileUploader = () => {
  const {
    uploadedFile,
    setUploadedFile,
    uploadedFileParams,
    setUploadedFileParams,
    uploadedS3Asset,
    setUploadedS3Asset,
    uploadInProgress,
    setUploadInProgress,
    uploadPercentage,
    setUploadPercentage,
    resetUploader,
  } = useStepEditorContext();

  const uploadFile = async (file: File) => {
    if (!file) {
      resetUploader();
      return;
    }

    // We need to do this here, before setting uploaded file, otherwise the preview loads
    // falls back to a vertical preview briefly before updating to a horizonal slideshow
    if (file.type.endsWith('pdf')) {
      try {
        const { width = 0, height = 0, num_pages = 0 } = (await getFileMetadata(file)) || {};
        if (width > 0 && height > 0 && num_pages > 0) {
          setUploadedFileParams({ width, height, num_pages });
        }
      } catch (e) {
        console.error(e);
      }
    }

    setUploadInProgress(true);
    setUploadedFile(file);

    const uploadPromise = uploadAssetToS3(file, setUploadPercentage);

    if (!uploadPromise) return null;

    try {
      const response = await uploadPromise;
      setUploadedS3Asset(response);
      setUploadInProgress(false);
      return response;
    } catch (e) {
      setUploadInProgress(false);
      return null;
    }
  };

  return {
    uploadFile,
    resetUploader,
    uploadedFile,
    uploadedFileParams,
    uploadedS3Asset,
    uploadInProgress,
    uploadPercentage,
  };
};
